import type { FullMetadata } from 'firebase/storage'
import { RenderFormat, type FileContentRendererConfig } from '@/content-viewer/store/schemas'
import { hasViewableMarkdownFile, isPdfFile } from './files-utils'

/**
 * Build the renderer config for legacy Drive files stored in the old uploads bucket.
 */
export function buildLegacyFileRendererConfig(fileMetadata: FullMetadata): FileContentRendererConfig | null {
  if (isPdfFile(fileMetadata)) {
    return {
      format: RenderFormat.PDF,
      filePath: fileMetadata.fullPath,
    }
  }

  if (hasViewableMarkdownFile(fileMetadata)) {
    return {
      format: RenderFormat.MARKDOWN,
      filePath: `${fileMetadata.fullPath}.md`,
    }
  }

  return null
}
